import { EditorInput, MenuBar, useInputEditor } from "@/components/RichText";
import { SocketManager } from "@/services";
import useChatStore from "@/store/chatStore";
import { cn } from "@/utils";
import { zodResolver } from "@hookform/resolvers/zod";
import React, { useEffect } from "react";
import { Controller, useForm } from "react-hook-form";
import { IoMdSend } from "react-icons/io";
import { MdClose } from "react-icons/md";
import { ChatInputSchema, ChatInputType } from "../../schemas/ChatInputSchema";

interface Props {
  roomId: number;
  messageId: number;
  originalMessage?: string;
}

const ChatInputEdit: React.FC<Props> = ({
  roomId,
  messageId,
  originalMessage,
}) => {
  const setEditingMessage = useChatStore((state) => state.setEditingMessage);
  const isConnectionReady = useChatStore((state) => state.isConnectionReady);
  const { editor, setEditorContent } = useInputEditor();

  // form control chat input
  const { control, handleSubmit, formState, reset } = useForm({
    defaultValues: {
      message: "",
    },
    resolver: zodResolver(ChatInputSchema),
  });

  // Set default value when originalMessage changes
  useEffect(() => {
    if (originalMessage) {
      reset({ message: originalMessage });
      setEditorContent(originalMessage);
    }
  }, [originalMessage]);

  // handle send message button click
  const handleSendMessage = (data: ChatInputType) => {
    if (!isConnectionReady) return;

    // emit edit message socket event
    if (data.message) {
      const socketManager = SocketManager.getInstance();
      socketManager.emitEditMessage({
        roomId: roomId.toString(),
        messageId: messageId,
        newMessage: data.message,
      });
    }

    // reset form
    setEditingMessage();
  };

  // Press Ctrl + Enter to send message
  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === "Enter" && e.ctrlKey) {
      e.preventDefault();
      handleSubmit(handleSendMessage)(); // Gọi submit function
    }
  };

  // Handle close edit mode
  const handleCloseEditMode = () => {
    setEditingMessage();
  };

  return (
    <div>
      {/* Edit title  */}
      <div className="flex items-center justify-between text-sm border-t p-2">
        <div>メッセージを編集する</div>
        <MdClose
          className="size-4 cursor-pointer"
          onClick={handleCloseEditMode}
        />
      </div>

      {/* Menu editor  */}
      <MenuBar editor={editor} />

      {/* Chat form input */}
      <div className="flex items-center gap-1 border-t px-1">
        <form
          onSubmit={handleSubmit(handleSendMessage)}
          className="flex items-center gap-1 w-full"
        >
          {/* Input message  */}
          <Controller
            control={control}
            name="message"
            render={({ field }) => (
              // <TextareaAutosize
              //   // {...register("message")}
              //   placeholder="メッセージを入力してください。"
              //   // className="flex-1 h-16 border-none outline-none"
              //   className="flex-1 border-none outline-none h-16 leading-6 py-4 resize-none"
              //   maxRows={5}
              //   // name="chat-input"
              //   onKeyDown={handleKeyDown}
              //   {...field}
              // />
              <EditorInput
                editor={editor}
                onChange={(v) => {
                  field.onChange(v);
                }}
                onKeyDown={handleKeyDown}
              />
            )}
          />

          {/* Button send message  */}
          <button
            type="submit"
            className="rounded-lg flex items-center justify-center hover:bg-grey-200 transition-colors duration-100 size-[36px]"
            title="送信"
          >
            <IoMdSend
              className={cn(
                "text-light_secondary size-[22px]",
                formState.isValid && "text-cyan"
              )}
            />
          </button>
        </form>
      </div>
    </div>
  );
};

export default ChatInputEdit;
